import * as Yup from "yup";

const DiscountCreationSchema = Yup.object({
  name: Yup.string().required("name is required"),
  discountValue: Yup.number().required("discountValue is required")
});
export default DiscountCreationSchema;
